import { createBrowserRouter, RouterProvider, Navigate, useParams } from 'react-router-dom';
import Landing from '@pages/Landing';
import Upload from '@pages/Upload';
import Results from '@pages/Results';
import Contact from '@pages/Contact';
import Payment from '@pages/Payment';
import Success from '@pages/Success';
import PasswordGate from '@components/PasswordGate';
import { routes } from '@lib/routes';

const gate = (element: JSX.Element) => <PasswordGate>{element}</PasswordGate>;

function LegacyResultsRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? routes.results(id) : routes.app} replace />;
}

const router = createBrowserRouter([
  { path: routes.landing, element: <Landing /> },
  { path: routes.app, element: gate(<Upload />) },
  { path: '/app/results/:id', element: gate(<Results />) },
  { path: routes.contact, element: gate(<Contact />) },
  { path: routes.payment, element: gate(<Payment />) },
  { path: routes.success, element: gate(<Success />) },
  { path: '/upload', element: <Navigate to={routes.app} replace /> },
  { path: '/preview', element: <Navigate to={routes.app} replace /> },
  { path: '/app/preview', element: <Navigate to={routes.app} replace /> },
  { path: '/results/:id', element: <LegacyResultsRedirect /> },
  { path: '/contact', element: <Navigate to={routes.contact} replace /> },
  { path: '/payment', element: <Navigate to={routes.payment} replace /> },
  { path: '/success', element: <Navigate to={routes.success} replace /> },
  { path: '*', element: <Navigate to={routes.landing} replace /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
